import useEffectiveWorkflowRunFilters from '@UI/Pages/WorkflowRuns/Hooks/useEffectiveWorkflowRunFilters';
import workflowRunFiltersSignal, {
	setWorkflowRunFilters,
} from '@UI/Pages/WorkflowRuns/Filters/Signals/workflowRunFiltersSignal';
import formFieldStylesPt from '@UI/Pages/WorkflowRuns/Filters/Helpers/formFieldStylesPt';
import * as React from 'react';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	readonly options: ReadonlyArray<{ readonly value: string; readonly label: string }>;
};

const StatusFilter: React.FC<Props> = ({ options }) => {
	const filters = useEffectiveWorkflowRunFilters();

	// `SelectButton`'s `onChange` always accepts the shape of a multi-select too — irrelevant here,
	// since this group is never `multiple`.
	const handleStatusChange = React.useCallback((status: string | readonly string[] | null) => {
		if (typeof status !== 'string') {
			return;
		}

		setWorkflowRunFilters(workflowRunFiltersSignal.peek().setStatus(status));
	}, []);

	return (
		<Dropdown<string>
			name="workflowRunStatus"
			label="Statut"
			options={[...options]}
			optionLabel="label"
			optionValue="value"
			value={filters.status}
			onChange={handleStatusChange}
			pt={formFieldStylesPt}
		/>
	);
};

export default StatusFilter;
